import { createReducer, on } from '@ngrx/store';
import { GhUserProfileDto } from '../../../api/administration/models/gh-user-profile-dto';
import { UserAuthActions } from './user-auth.actions';
import { AuthActions } from '../../auth/auth.actions';

export interface UserAuthState {
  userDetails: GhUserProfileDto | null;
  isLoading: boolean;
  error: string | null;
  /** Increments on every profile load so an older response cannot overwrite a newer one. */
  loadId: number;
}

const initialState: UserAuthState = {
  userDetails: null,
  isLoading: false,
  error: null,
  loadId: 0,
};

export const userAuthReducer = createReducer(
  initialState,
  on(UserAuthActions.loadUserDetails, state => ({
    ...state,
    isLoading: true,
    error: null,
    loadId: state.loadId + 1,
  })),
  on(UserAuthActions.loadUserDetailsSuccess, (state, { response }) => ({
    ...state,
    isLoading: false,
    userDetails: response?.data?.[0] ?? null,
    error: null,
  })),
  on(UserAuthActions.loadUserDetailsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(UserAuthActions.clearUser, () => initialState),
  on(AuthActions.logout, () => initialState)
);
